/* M&T — WhatsApp com contexto: a conversa ja comeca sabendo qual produto a pessoa estava vendo. */
(function () {
  'use strict';

  var GLIFO = '<svg class="mtwa__i" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.47c-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.14-1.18-.06-.11-.22-.17-.47-.29Z"/></svg>';

  function cfg() {
    var el = document.getElementById('mtwa-cfg');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* qual variante esta selecionada agora — se a PDP nao expuser, seguimos sem isso */
  function variante(c) {
    if (!c.produto || !c.produto.variantes || !c.produto.variantes.length) return '';
    var campo = document.getElementById('mtpdp-id');
    var id = campo && campo.value ? parseInt(campo.value, 10) : 0;
    var v = null, i;
    for (i = 0; i < c.produto.variantes.length; i++) {
      if (c.produto.variantes[i].id === id) { v = c.produto.variantes[i]; break; }
    }
    if (!v || !v.titulo || v.titulo === 'Default Title') return '';
    return v.titulo;
  }

  function mensagem(c) {
    if (!c.produto) return 'oi! vim pelo site ✨ queria tirar uma dúvida.';
    var t = 'oi! vim pelo site ✨ queria saber sobre: ' + c.produto.titulo;
    var v = variante(c);
    if (v) t += ' (' + v + ')';
    return t + '\n' + c.produto.url;
  }

  function href(c) {
    return 'https://wa.me/' + c.numero + '?text=' + encodeURIComponent(mensagem(c));
  }

  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  pronto(function () {
    var c = cfg();
    if (!c || !c.numero) return;

    /* flutuante, em toda a loja */
    var f = document.createElement('a');
    f.className = 'mtwa';
    f.target = '_blank';
    f.rel = 'noopener';
    f.setAttribute('aria-label', 'falar com a gente no WhatsApp');
    f.innerHTML = GLIFO + '<span class="mtwa__t">falar com a gente</span>';
    document.body.appendChild(f);

    /* na PDP tem barra fixa de compra: sobe pra nao encostar */
    if (document.getElementById('mtpdp-float') || document.querySelector('.mtpdp__float')) {
      f.classList.add('mtwa--acima');
    }

    /* botao secundario junto da compra — so entra se o ancoradouro existir */
    var b = null;
    var compra = document.getElementById('mtpdp-buy');
    if (c.produto && compra && compra.parentNode) {
      b = document.createElement('a');
      b.className = 'mtwa-pdp';
      b.target = '_blank';
      b.rel = 'noopener';
      b.innerHTML = GLIFO + '<span>tirar uma dúvida no WhatsApp</span>';
      compra.parentNode.insertBefore(b, compra.nextSibling);
    }

    /* a variante pode mudar depois que a pagina carrega — o link e remontado na hora do clique */
    function atualiza() {
      var h = href(c);
      f.href = h;
      if (b) b.href = h;
    }
    atualiza();
    f.addEventListener('mousedown', atualiza);
    f.addEventListener('touchstart', atualiza, { passive: true });
    if (b) {
      b.addEventListener('mousedown', atualiza);
      b.addEventListener('touchstart', atualiza, { passive: true });
    }
  });
})();
